import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";

const NewRecordCollectionModal = ({ show, handleClose, user_id, db_id, coll_id, fetchCollection, pageData }) => {
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });
    const [data, setData] = useState([{ key: "", value: "", type: "string" }]);

    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setData([{ key: "", value: "", type: "string" }]);
        fetchCollection(user_id, db_id, coll_id, pageData);
    };

    const handleChange = (index, field, value) => {
        const updated = [...data];
        updated[index][field] = value;
        setData(updated);
    };

    const addPair = () => {
        setData([...data, { key: "", value: "", type: "string" }]);
    };

    const removePair = (index) => {
        if (data.length > 1) {
            const updated = data.filter((_, i) => i !== index);
            setData(updated);
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        setError({ message: "", display: false });

        try {
            // Inside handleSubmit()
            const records = data.reduce((acc, { key, value, type }) => {
                if (key) {
                    let parsedValue;

                    switch (type) {
                        case "int":
                            parsedValue = parseInt(value);
                            break;
                        case "float":
                            parsedValue = parseFloat(value);
                            break;
                        case "boolean":
                            parsedValue = value === "true";
                            break;
                        case "null":
                            parsedValue = null;
                            break;
                        case "array":
                            parsedValue = JSON.parse(value); // Expecting JSON array input
                            break;
                        case "object":
                            parsedValue = JSON.parse(value); // Expecting JSON object input
                            break;
                        case "binary":
                            parsedValue = atob(value); // Decoded from base64
                            break;
                        case "timestamp":
                            parsedValue = new Date(value).toISOString();
                            break;
                        default:
                            parsedValue = value;
                    }

                    acc[key] = parsedValue;
                }
                return acc;
            }, {});


            const payload = {
                user_id,
                db_id,
                coll_id,
                records: records
            };

            const response = await fetch("https://backend.erioon.com/save_collection_data", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Failed to save data");
            }

            CloseModal();
        } catch (err) {
            setError({ message: err.message, display: true });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={CloseModal} className="modal_api_connection">
            <div className="share_main_cont_modal">
                <p className="share_label">
                    <i className="fa-solid fa-plus"></i> New record
                </p>

                <div className="pair_container">
                    {data.map((pair, index) => (
                        <div
                            key={index}
                            className="pair_row"
                            style={{ display: "flex", gap: "8px", marginBottom: "10px", alignItems: "center" }}
                        >
                            <input
                                type="text"
                                placeholder="Key"
                                value={pair.key}
                                onChange={(e) => handleChange(index, "key", e.target.value)}
                                className="input_data_pair"
                            />

                            <select
                                value={pair.type}
                                onChange={(e) => handleChange(index, "type", e.target.value)}
                                className="input_data_pair_select"
                            >
                                <option value="string">String</option>
                                <option value="int">Integer</option>
                                <option value="float">Float</option>
                                <option value="boolean">Boolean</option>
                                <option value="null">Null</option>
                                <option value="array">Array</option>
                                <option value="object">Object</option>
                                <option value="binary">Binary (Base64)</option>
                                <option value="date">Date</option>
                                <option value="time">Time</option>
                                <option value="timestamp">Timestamp</option>
                            </select>

                            {pair.type === "boolean" ? (
                                <select
                                    value={pair.value}
                                    onChange={(e) => handleChange(index, "value", e.target.value)}
                                    className="input_data_pair"
                                >
                                    <option value="true">true</option>
                                    <option value="false">false</option>
                                </select>
                            ) : pair.type === "timestamp" ? (
                                <input
                                    type="datetime-local"
                                    value={pair.value}
                                    onChange={(e) => handleChange(index, "value", e.target.value)}
                                    className="input_data_pair"
                                />
                            ) : pair.type === "date" ? (
                                <input
                                    type="date"
                                    value={pair.value}
                                    onChange={(e) => handleChange(index, "value", e.target.value)}
                                    className="input_data_pair"
                                />
                            ) : pair.type === "time" ? (
                                <input
                                    type="time"
                                    value={pair.value}
                                    onChange={(e) => handleChange(index, "value", e.target.value)}
                                    className="input_data_pair"
                                />
                            ) : (
                                <input
                                    type={pair.type === "int" || pair.type === "float" ? "number" : "text"}
                                    placeholder="Value"
                                    value={pair.value}
                                    onChange={(e) => handleChange(index, "value", e.target.value)}
                                    className="input_data_pair"
                                />
                            )}

                            {data.length > 1 && (
                                <button
                                    type="button"
                                    onClick={() => removePair(index)}
                                    className="remove_pair_btn"
                                >
                                    <i className="fa-solid fa-minus"></i>
                                </button>
                            )}
                        </div>
                    ))}

                    <button type="button" onClick={addPair} className="add_pair_btn">
                        <i className="fa-solid fa-plus"></i> New pair
                    </button>
                </div>
            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button className="save_btn" onClick={handleSubmit}>
                        {loading ? <Spinner loading={loading} /> : t.save}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default NewRecordCollectionModal;
